import { apiGet } from "@/lib/apiClient";
import type { DecorationCatalog } from "../shared/design-catalog.types";

export function fetchDecorationCatalog(): Promise<DecorationCatalog> {
  return apiGet<DecorationCatalog>("/catalog/get-print-type-decorations");
}
